// extracted by mini-css-extract-plugin
export var lang = "langSwitch-module--lang--a2N9a";
export var inner = "langSwitch-module--inner--UknNo";